import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import FlashMessage from "../FlashMessage";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";
import { postEncryptedFormFromFormData } from "../../utils/eposApi";
import { fetchProformaInvoice } from "../../utils/proformaInvoiceApi";
import Select from "react-select";
import { format } from "date-fns";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import Swal from "sweetalert2";
import { size } from "lodash";

const EditProforma_sdm = () => {
  const { orderId } = useParams();
  const tableRef = useRef(null);
  const [shopDetails, setShopDetails] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [newProductDetails, setNewProductDetails] = useState([]);
  const [tableRow, setTableRow] = useState([]);
  const [totalVal, setTotalVal] = useState({
    totalstd: 0,
    totalzeroGoods: 0,
    totalTax: 0,
    totalCess: 0,
    orderDiscount: 0,
    grandTotal: 0,
    invDiscount: 0,
    over_all_discount: 0,
    orderDiscountPercentage: 0,
    orderDiscountType: "",
  });

  const [flashMessage, setFlashMessage] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [productInputValue, setProductInputValue] = useState("");
  const [orderOptions, setOrderOptions] = useState([]);
  const [orderType, setOrderType] = useState("");
  const [orderPrice, setOrderPrice] = useState("");
  const [newTaxRate, setNewTaxRate] = useState("");
  const [isContractPriceApplied, setisContractPriceApplied] = useState("N");
  const [addOrderQty, setAddOrderQty] = useState("");
  const [newProducts, setNewProducts] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem('token');
  const company_tax_type = localStorage.getItem("company_tax_type");
  const showCessRate = localStorage.getItem("showCessRate");
  const navigateToGRNList = useNavigate();

  const handleQtyChange = (event) => {
    setAddOrderQty(event.target.value);
  };

  const handlePriceChange = (event) => {
    setOrderPrice(event.target.value);
  };

  const handleAddressChange = (event) => {
    //setOrderPrice(event.target.value);

    setOrderDetails((prevState) => ({
      ...prevState, // Spread the previous state to keep other values unchanged
      delivery_address: event.target.value, // Update only the `orderDiscount` field
    }));
  };
  const handleChangestaffNote = (event) => {
    //setOrderPrice(event.target.value);

    setOrderDetails((prevState) => ({
      ...prevState, // Spread the previous state to keep other values unchanged
      staff_note: event.target.value, // Update only the `orderDiscount` field
    }));
  };

  const handleInputChange = (inputValue) => {
    fetchProductNameOptions(inputValue);
  };

  const handleChangeOrderType = (event) => {
    const value = event.target.value;
    setOrderType(value);
  };

  const handleChange = (selectedOption) => {
    setProductInputValue(selectedOption);

    setOrderType("");
    setOrderPrice("");
    setAddOrderQty("");
    if (selectedOption) {
      const selectedProduct = productOptions.find(
        (option) => option.value === selectedOption.value
      );

      fetchOrderOptions(selectedProduct ? selectedProduct.split : 3);
    } else {
      fetchOrderOptions(3);
    }
  };

  const fetchOrderOptions = async (splitValue) => {
    //console.log(splitValue);
    let data = [];
    if (splitValue == 2) {
      data = [
        { box: "Box", picec: "Box" },
        { box: "Piece", picec: "Piece" },
      ];
    } else if (splitValue == 0) {
      data = [{ box: "Box", picec: "Box" }];
    } else if (splitValue == 1) {
      data = [{ box: "Piece", picec: "Piece" }];
    } else {
      data = [];
    }

    const formattedOptions = data.map((item) => ({
      label: item.box,
      value: item.picec,
    }));
    setOrderOptions(formattedOptions);
  };

  const deleteProductAPI = async (
    productId,
    orderId,
    Id,
    orderType,
    quantity,
    promo_name,
    date,
    time
  ) => {
    const Url = `${config.API_URL}/delete_order_product`;
    try {
      const formData = new FormData();
      formData.append("productId", productId);

      const response = await fetch(Url, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success === true) {
        let newArray = productDetails.filter(
          (item) => item.id !== String(productId)
        );
        const updatedProductDetails = productDetails.filter(
          (item) => item.id !== String(productId)
        );

        setProductDetails(updatedProductDetails);

        // Recalculate combo quantities
        const updatedComboQty = sumComboQuantities(updatedProductDetails);
        // console.log("Updated Combo Quantity:", updatedComboQty);
        const deletedProduct = productDetails.find(
          (item) => item.id === String(productId)
        );
        const promo_id = deletedProduct ? deletedProduct.promo_id : 0;
        const output =
          orderType === "box" ? "0" : orderType === "piece" ? "1" : "";
        const order_type = output;
        if (promo_name === "combo") {
          RemoveComboProduct(
            orderId,
            Id,
            order_type,
            quantity,
            promo_name,
            date,
            time,
            promo_id
          );
        } else {
          const Comboqty = sumComboQuantitiesByPromoId(
            productDetails,
            promo_id
          );
          newInvoice(orderId, Id, order_type, 0, Comboqty, time, date);
        }
        setProductDetails(newArray);
        setTimeout(() => {
          const api = $("#salesInvoice").DataTable();
          if (orderDetails.group_id == 3) {
            getOrderDiscount(
              api,
              orderDetails.group_id,
              orderDetails.time,
              orderDetails.date
            );
          }
          calculateTotals(api);
        }, 100);
        let productData = newArray;
        let orderData = orderDetails;

        // WITHOUT CONTRACT PRODUCTS
        const totalstd_without_contract = productData
          .filter(
            (item) =>
              item.item_tax !== "0.00" &&
              item.item_tax != null &&
              item.isContractPriceApplied === "N"
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

        const totalzeroGoods_without_contract = productData
          .filter(
            (item) =>
              (item.item_tax === "0.00" || item.item_tax === null) &&
              item.isContractPriceApplied === "N"
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

        const totalTax_without_contract = productData
          .filter(
            (item) =>
              item.item_tax !== "0.00" &&
              item.item_tax != null &&
              item.isContractPriceApplied === "N"
          )
          .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

        // WITH CONTRACT PRODUCTS
        const totalstd_with_contract = productData
          .filter(
            (item) =>
              item.item_tax !== "0.00" &&
              item.item_tax != null &&
              item.isContractPriceApplied === "Y"
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

        const totalzeroGoods_with_contract = productData
          .filter(
            (item) =>
              (item.item_tax === "0.00" || item.item_tax === null) &&
              item.isContractPriceApplied === "Y"
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

        const totalTax_with_contract = productData
          .filter(
            (item) =>
              item.item_tax !== "0.00" &&
              item.item_tax != null &&
              item.isContractPriceApplied === "Y"
          )
          .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

        // COMBINE TOTALS
        const totalstd = totalstd_without_contract + totalstd_with_contract;
        const totalzeroGoods =
          totalzeroGoods_without_contract + totalzeroGoods_with_contract;
        const totalTax = totalTax_without_contract + totalTax_with_contract;

        let InvDiscount = 0;
        let totalVat = 0;
        let orderDiscount = 0;
        let grandTotal = 0;
        let totalDiscountOnVat = 0;

        // Calculate discount percentage (only applies to non-contract items)
        if (orderData.over_all_discount > 0) {
          totalDiscountOnVat += parseFloat(orderData.over_all_discount);
        }

        if (parseFloat(orderData.percentage) > 0) {
          totalDiscountOnVat += parseFloat(orderData.percentage);
        }

        // Apply VAT discount only to non-contract VAT
        const discountedVatWithoutContract =
          parseFloat(totalTax_without_contract) -
          (parseFloat(totalTax_without_contract) *
            parseFloat(totalDiscountOnVat)) /
          100;

        // Total VAT = discounted non-contract VAT + full contract VAT
        totalVat = discountedVatWithoutContract + totalTax_with_contract;

        orderDiscount = parseFloat(orderData.order_discount);

        // Apply invoice discount only to non-contract products
        const totalWithoutContract =
          totalzeroGoods_without_contract + totalstd_without_contract;
        if (orderData.over_all_discount > 0) {
          InvDiscount =
            (totalWithoutContract * parseFloat(orderData.over_all_discount)) /
            100;
        } else {
          InvDiscount = 0.0;
        }

        // Calculate grand total
        const total = totalzeroGoods + totalstd;
        grandTotal =
          total +
          Number(totalVat.toFixed(2)) -
          Number(InvDiscount.toFixed(2)) -
          orderDiscount;

        // Set the total values
        setTotalVal({
          totalstd: formatNumber(totalstd),
          totalzeroGoods: formatNumber(totalzeroGoods),
          totalTax: formatNumber(totalVat),
          orderDiscount: formatNumber(orderDiscount),
          invDiscount: formatNumber(InvDiscount),
          over_all_discount: formatNumber(orderData.over_all_discount),
          grandTotal: formatNumber(grandTotal),
          orderDiscountPercentage: orderData.percentage,
          orderDiscountType: orderData.discount_type,
          // Additional values for debugging/reference
          totalstd_without_contract: formatNumber(totalstd_without_contract),
          totalzeroGoods_without_contract: formatNumber(
            totalzeroGoods_without_contract
          ),
          totalTax_without_contract: formatNumber(totalTax_without_contract),
          totalstd_with_contract: formatNumber(totalstd_with_contract),
          totalzeroGoods_with_contract: formatNumber(
            totalzeroGoods_with_contract
          ),
          totalTax_with_contract: formatNumber(totalTax_with_contract),
          discountedVatWithoutContract: formatNumber(
            discountedVatWithoutContract
          ),
          totalDiscountOnVat: formatNumber(totalDiscountOnVat),
        });
      } else {
        console.log("Failed to delete product");
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  const sumComboQuantities = (productDetails) => {
    if (!Array.isArray(productDetails)) {
      return 0; // Return 0 if productDetails is not an array
    }
    return productDetails
      .filter((item) => item.promo_name === "combo")
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  };
  const sumComboQuantitiesByPromoId = (productDetails, promo_id) => {
    if (!Array.isArray(productDetails)) return 0;
    return productDetails
      .filter(
        (item) =>
          item.promo_name === "combo" &&
          item.promo_id === promo_id
      )
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  };
  const fetchProductNameOptions = async () => {
    const formData = new FormData();
    const apiSalesRapUrl = `${config.API_URL}/ws_get_product`;

    try {
      const response = await fetch(apiSalesRapUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();

      // console.log(data);

      if (Array.isArray(data.products_details)) {
        const formattedOptions = data.products_details.map((item) => ({
          label: item.code + " " + item.name + "-" + item.size,
          value: item.id,
          split: item.split,
          size: item.size,
          name: item.name,
          code: item.code,
          size: item.size,
        }));
        setProductOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching customer options:", error);
    }
  };

  const fetchInvoice = async () => {
    try {
      const data = await fetchProformaInvoice(orderId, token);
      setShopDetails(data.details.shop_details);
      setOrderDetails(data.details.orderDetails[0]);
      setProductDetails(data.details.product_details);

      let productData = data.details.product_details;
      let orderData = data.details.orderDetails[0];

      // Calculate totals for without contract products
      const totalstd_without_contract = productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "N"
        )
        .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

      const totalzeroGoods_without_contract = productData
        .filter(
          (item) =>
            (item.item_tax === "0.00" || item.item_tax === null) &&
            item.isContractPriceApplied === "N"
        )
        .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

      const totalTax_without_contract = productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "N"
        )
        .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

      // Calculate totals for with contract products
      const totalstd_with_contract = productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "Y"
        )
        .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

      const totalzeroGoods_with_contract = productData
        .filter(
          (item) =>
            (item.item_tax === "0.00" || item.item_tax === null) &&
            item.isContractPriceApplied === "Y"
        )
        .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

      const totalTax_with_contract = productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "Y"
        )
        .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

      // Calculate CESS totals
      const totalCess_without_contract = showCessRate === 'Y' ? productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "N"
        )
        .reduce((sum, item) => {
          const itemSubtotal = parseFloat(item.subtotal) || 0;
          const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
          return sum + ((itemSubtotal * itemCessRate) / 100);
        }, 0) : 0;

      const totalCess_with_contract = showCessRate === 'Y' ? productData
        .filter(
          (item) =>
            item.item_tax !== "0.00" &&
            item.item_tax != null &&
            item.isContractPriceApplied === "Y"
        )
        .reduce((sum, item) => {
          const itemSubtotal = parseFloat(item.subtotal) || 0;
          const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
          return sum + ((itemSubtotal * itemCessRate) / 100);
        }, 0) : 0;

      // Combine totals
      const totalstd = totalstd_without_contract + totalstd_with_contract;
      const totalzeroGoods =
        totalzeroGoods_without_contract + totalzeroGoods_with_contract;
      const totalCess = totalCess_without_contract + totalCess_with_contract;

      // Only apply discounts to without contract
      let totalDiscountOnVat = 0;
      if (orderData.over_all_discount > 0) {
        totalDiscountOnVat += parseFloat(orderData.over_all_discount);
      }
      if (parseFloat(orderData.percentage) > 0) {
        totalDiscountOnVat += parseFloat(orderData.percentage);
      }

      // Apply VAT discount only to without contract VAT
      const discountedVatWithoutContract =
        totalTax_without_contract -
        (totalTax_without_contract * totalDiscountOnVat) / 100;
      const totalVat = discountedVatWithoutContract + totalTax_with_contract;

      // Only apply overall discount to without contract products
      const totalWithoutContract =
        totalzeroGoods_without_contract + totalstd_without_contract;
      let InvDiscount = 0;
      if (orderData.over_all_discount > 0) {
        InvDiscount =
          (totalWithoutContract * parseFloat(orderData.over_all_discount)) /
          100;
      } else {
        InvDiscount = 0.0;
      }

      const total = totalzeroGoods + totalstd;
      const orderDiscount = parseFloat(orderData.order_discount) || 0;
      const grandTotal =
        total +
        Number(totalVat.toFixed(2)) +
        Number(totalCess.toFixed(2)) -
        Number(InvDiscount.toFixed(2)) -
        orderDiscount;

      // Set the total values
      setTotalVal({
        totalstd: formatNumber(totalstd),
        totalzeroGoods: formatNumber(totalzeroGoods),
        totalTax: formatNumber(totalVat),
        totalCess: formatNumber(totalCess),
        orderDiscount: formatNumber(orderDiscount),
        invDiscount: formatNumber(InvDiscount),
        over_all_discount: formatNumber(orderData.over_all_discount),
        grandTotal: formatNumber(grandTotal),
        orderDiscountPercentage: orderData.percentage,
        orderDiscountType: orderData.discount_type,
      });
    } catch (error) {
      console.error("api fail Error fetching Not Order Report:", error);
    }
  };

  useEffect(() => {
    fetchInvoice();
    fetchProductNameOptions();
  }, []);

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };

  useEffect(() => {
    // console.log(productDetails);
    const table = $("#salesInvoice").DataTable({
      pageLength: 50,
      paging: false,
      lengthMenu: [10, 20, 50],
      searching: false,
      ordering: false,
      info: false,
      responsive: true,
      autoWidth: false,
      data: productDetails,
      columns: [
        { data: null, width: "3%" },
        {
          data: null,
          width: "6%",
          className: "text-center",
          render: function (data, type, row) {
            if (row.is_promoted === "1") {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<span style="color: #f14240;">${row.product_code}${row.promo_product}${row.free_product}${row.ContractPrice}</span>`;
              } else if (row.unit_quantity != row.quantity) {
                // Apply color to all columns when unit_quantity != quantity
                return `<span style="color:#009688;">${row.product_code}${row.promo_product}${row.free_product}${row.ContractPrice}</span>`;
              } else {
                return `<span>${row.product_code}${row.promo_product}${row.free_product}${row.ContractPrice}</span>`;
              }
            } else {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<span style="color: #f14240;">${row.product_code}${row.promo_product}${row.free_product} ${row.ContractPrice}</span>`;
              } else if (row.unit_quantity != row.quantity) {
                // Apply color to all columns when unit_quantity != quantity
                return `<span style="color:#009688;">${row.product_code}${row.promo_product}${row.free_product}${row.ContractPrice}</span>`;
              } else {
                return `<div>${row.product_code}${row.promo_product}${row.free_product}${row.ContractPrice}</div>`;
              }
            }
          },
        },
        {
          data: "product_name",
          render: function (data, type, row) {
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style="color: #f14240;">${row.product_name} - ${row.size}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style="color:#009688;">${row.product_name} - ${row.size}</span>`;
            } else {
              return `<span>${row.product_name} - ${row.size}</span>`;
            }
          },
        },
        {
          data: null,
          width: "4%",
          className: "text-center",
          render: function (data, type, row) {
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style="color: #f14240;">${parseInt(
                row.unit_quantity
              )}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style="color:#009688;">${parseInt(
                row.unit_quantity
              )}</span>`;
            } else {
              return `<span>${parseInt(row.unit_quantity)}</span>`;
            }
          },
        },
        {
          data: null,
          width: "6%",
          className: "text-center",
          render: function (data, type, row) {
            const orderCount = row.quantity ? parseInt(row.quantity) : 0;

            if (row.is_promoted === "1") {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<span style="color: #f14240;">${orderCount}</span>`;
              } else if (row.unit_quantity != row.quantity) {
                return `<span style="color:#009688;">${orderCount}</span>`;
              } else {
                return `<span>${orderCount}</span>`;
              }
            } else {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<div><input type="text" style="color: #f14240;" data-id="${row.id}" class="form-control order-qty" value="${orderCount}" min="0" /></div>`;
              } else if (row.unit_quantity != row.quantity) {
                return `<div><input type="text" style="color:#009688;" data-id="${row.id}" class="form-control order-qty" value="${orderCount}" min="0" /></div>`;
              } else {
                return `<div><input type="text" data-id="${row.id}" class="form-control order-qty" value="${orderCount}" min="0" /></div>`;
              }
            }
          },
        },
        {
          data: "current_stock",
          className: "text-center",
          width: "8%",
          render: function (data, type, row) {
            const currentStock = row.current_stock != null ? row.current_stock : 0;
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style=\"color: #f14240;\">${currentStock}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style=\"color:#009688;\">${currentStock}</span>`;
            } else {
              return `<span>${currentStock}</span>`;
            }
          },
        },
        {
          data: "order_type",
          className: "text-center",
          width: "8%",
          render: function (data, type, row) {
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style="color: #f14240;">${row.order_type}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style="color:#009688;">${row.order_type}</span>`;
            } else {
              return `<span>${row.order_type}</span>`;
            }
          },
        },

        {
          data: "unit_price",
          width: "6%",
          className: "text-center",
          render: function (data, type, row) {
            const unitPriceVal = row.unit_price ? row.unit_price : 0;
            if (row.isContractPriceApplied === "Y") {
              return `<input type="text" data-id="${row.id}" class="form-control unit-price" value="${unitPriceVal}" min="0.01" readonly style="background:#f5f5f5;cursor:not-allowed;" />`;
            }
            if (row.is_promoted === "1") {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<span style="color: #f14240;">${unitPriceVal}</span>`;
              } else if (row.unit_quantity != row.quantity) {
                return `<span style="color:#009688;">${unitPriceVal}</span>`;
              } else {
                return `<span>${unitPriceVal}</span>`;
              }
            } else {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<input type="text" style="color: #f14240;" data-id="${row.id}" class="form-control unit-price" value="${unitPriceVal}" min="0.01" />`;
              } else if (row.unit_quantity != row.quantity) {
                return `<input type="text" style="color:#009688;" data-id="${row.id}" class="form-control unit-price" value="${unitPriceVal}" min="0.01" />`;
              } else {
                return `<input type="text" data-id="${row.id}" class="form-control unit-price" value="${unitPriceVal}" min="0.01" />`;
              }
            }
          },
        },

        {
          data: "discount",
          width: "6%",
          className: "text-center",
          render: function (data, type, row) {
            const item_discountVal = row.item_discount ? row.item_discount : 0;
            const discountpercentage = row.discount
              ? parseInt(row.discount, 10)
              : 0;
            if (row.isContractPriceApplied === "Y") {
              return `<span>${item_discountVal}</span>`;
            }
            if (row.is_promoted === "1") {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<span style="color: #f14240;">${item_discountVal}</span>`;
              } else if (row.unit_quantity != row.quantity) {
                return `<span style="color:#009688;">${item_discountVal}</span>`;
              } else {
                return `<span>${item_discountVal}</span>`;
              }
            } else {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `<input type="text" style="color: #f14240;" data-id="${row.id}" class="form-control discountpercentage" value="${discountpercentage}" min="0.01" />`;
              } else if (row.unit_quantity != row.quantity) {
                return `<input type="text" style="color:#009688;" data-id="${row.id}" class="form-control discountpercentage" value="${discountpercentage}" min="0.01" />`;
              } else {
                return `<input type="text" data-id="${row.id}" class="form-control discountpercentage" value="${discountpercentage}" min="0.01" />`;
              }
            }
          },
        },
        {
          data: "item_tax",
          className: "text-center",
          width: "8%",
          render: function (data, type, row) {
            const item_tax = parseFloat(row.item_tax) || 0;
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style="color: #f14240;">${item_tax.toFixed(
                2
              )}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style="color:#009688;">${item_tax.toFixed(
                2
              )}</span>`;
            } else {
              return `<span>${item_tax.toFixed(2)}</span>`;
            }
          },
        },
        {
          data: "subtotal",
          className: "text-center",
          width: "8%",
          render: function (data, type, row) {
            const subtotal = parseFloat(row.subtotal) || 0;
            if (row.discount == "100.00" || row.discount == 100.0) {
              return `<span style="color: #f14240;">${subtotal.toFixed(
                2
              )}</span>`;
            } else if (row.unit_quantity != row.quantity) {
              return `<span style="color:#009688;">${subtotal.toFixed(
                2
              )}</span>`;
            } else {
              return `<span>${subtotal.toFixed(2)}</span>`;
            }
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            if (row.is_promoted !== "1") {
              if (row.discount == "100.00" || row.discount == 100.0) {
                return `
            <a href="#" class="btn-delete"  style="color: #f14240;" data-id="${row.id}" tool-tip="Remove product">
              <i class="fa fa-trash"></i>
            </a>
            `;
              } else {
                return `
            <a href="#" class="btn-delete" data-id="${row.id}" tool-tip="Remove product">
              <i class="fa fa-trash"></i>
            </a>
            `;
              }
            } else {
              return "";
            }
          },
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            $(cell)
              .find(".btn-delete")
              .on("click", function (e) {
                e.preventDefault();
                const Id = $(this).data("id");
                Swal.fire({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, delete it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    deleteProductAPI(
                      Id,
                      orderDetails.id,
                      rowData.product_id,
                      rowData.order_type,
                      rowData.quantity,
                      rowData.promo_name,
                      orderDetails.date,
                      orderDetails.time
                    );
                    Swal.fire(
                      "Deleted!",
                      "Your product has been deleted.",
                      "success"
                    );
                  }
                });
              });
          },
        },
      ],
      columnDefs: [
        {
          targets: [0],
          orderable: false,
        },
      ],
      drawCallback: function (settings) {
        const api = this.api();
        const startIndex = api.page.info().start;

        api
          .column(0, { page: "current" })
          .nodes()
          .each(function (cell, i) {
            cell.innerHTML = startIndex + i + 1;
          });

        $("#salesInvoice").on("draw.dt", function () {
          $("#salesInvoice")
            .off("focusout", ".order-qty")
            .on("focusout", ".order-qty", function () {
              const id = $(this).data("id");

              let newValue = parseFloat($(this).val()) || 0;

              if (newValue < 0) {
                newValue = 0;
                $(this).val(newValue);
              }

              const rowIdx = api
                .rows()
                .indexes()
                .toArray()
                .find((idx) => api.row(idx).data().id == id);

              if (rowIdx !== undefined) {
                const rowData = api.row(rowIdx).data();
                rowData.quantity = newValue;
                // alert(newValue);

                const unit_Price = parseFloat(rowData.unit_price) || 0;
                const discount = parseFloat(rowData.discount) || 0;

                const unitPrice = parseFloat(
                  unit_Price - unit_Price * (discount / 100)
                );
                // alert(newValue);
                // alert(unitPrice);
                rowData.subtotal = newValue * unitPrice;
                // alert(`Subtotal: ${rowData.subtotal.toFixed(2)}`);
                const itemVAT = parseFloat(rowData.tax_rate_percent) || 0;
                // alert(discount);
                rowData.item_tax =
                  itemVAT != 0.0
                    ? ((newValue * unitPrice * itemVAT) / 100).toFixed(2)
                    : "0.00";

                api.row(rowIdx).invalidate().draw();
                const orderId = orderDetails.id;
                const productId = rowData.product_id;
                const output =
                  rowData.order_type === "box"
                    ? "0"
                    : rowData.order_type === "piece"
                      ? "1"
                      : "";
                const order_type = output;
                const qty = newValue;
                const Comboqty = sumComboQuantitiesByPromoId(
                  productDetails,
                  rowData.promo_id
                );
                //console.log("Comboqty",Comboqty);
                if (rowData.isContractPriceApplied === "N") {
                  newInvoice(
                    orderId,
                    productId,
                    order_type,
                    qty,
                    Comboqty,
                    orderDetails.time,
                    orderDetails.date
                  );
                }
                if (orderDetails.group_id == 3) {
                  getOrderDiscount(
                    api,
                    orderDetails.group_id,
                    orderDetails.time,
                    orderDetails.date
                  );
                }

                calculateTotals(api);
              } else {
                console.warn(`No row found with ID: ${id}`);
              }
            });

          $("#salesInvoice")
            .off("focusout", ".unit-price")
            .on("focusout", ".unit-price", function () {
              let newValue = parseFloat($(this).val()) || 0;

              if (newValue < 0) {
                newValue = 0;
                $(this).val(newValue);
              }

              const id = $(this).data("id");
              const rowIdx = api
                .rows()
                .indexes()
                .toArray()
                .find((idx) => api.row(idx).data().id == id);

              if (rowIdx !== undefined) {
                const rowData = api.row(rowIdx).data();
                const discount = parseFloat(rowData.discount) || 0;

                const discountedValue = newValue - newValue * (discount / 100);

                rowData.unit_price = formatNumber(newValue);
                const pdtQty = parseFloat(rowData.quantity) || 0;

                rowData.subtotal = formatNumber(discountedValue * pdtQty);

                const itemVAT = parseFloat(rowData.tax_rate_percent) || 0;

                rowData.item_tax =
                  itemVAT != 0.0
                    ? ((discountedValue * pdtQty * itemVAT) / 100).toFixed(2)
                    : 0;

                api.row(rowIdx).invalidate().draw();

                if (orderDetails.group_id == 3) {
                  getOrderDiscount(
                    api,
                    orderDetails.group_id,
                    orderDetails.time,
                    orderDetails.date
                  );
                }

                calculateTotals(api);
              } else {
                console.warn(`No row found with ID: ${id}`);
              }
            });

          $("#salesInvoice")
            .off("focusout", ".discountpercentage")
            .on("focusout", ".discountpercentage", function () {
              let discountpercentage = parseFloat($(this).val()) || 0;
              // if (discountpercentage < 0) {
              //   discountpercentage = 0;
              //   $(this).val(discountpercentage);
              // }
              if (discountpercentage < 0 || discountpercentage > 100) {
                Swal.fire({
                  title: "Error",
                  text: "Please enter a valid discount percentage between 0 and 100.",
                  icon: "error",
                  timer: 2500,
                  showConfirmButton: false,
                });
                discountpercentage = 0;
                $(this).val(discountpercentage);
                return;
              }

              const id = $(this).data("id");
              const rowIdx = api
                .rows()
                .indexes()
                .toArray()
                .find((idx) => api.row(idx).data().id == id);

              if (rowIdx !== undefined) {
                // Initialize rowData before using it
                const rowData = api.row(rowIdx).data();

                // Now you can safely access rowData properties
                const unit_Price = parseFloat(rowData.unit_price) || 0;

                const discountedValue =
                  unit_Price - unit_Price * (discountpercentage / 100);

                rowData.unit_price = formatNumber(unit_Price);
                const pdtQty = parseFloat(rowData.quantity) || 0;
                rowData.discount = formatNumber(discountpercentage);
                rowData.item_discount = formatNumber(discountedValue);
                rowData.subtotal = formatNumber(discountedValue * pdtQty);
                const itemVAT = parseFloat(rowData.tax_rate_percent) || 0;
                rowData.item_tax =
                  itemVAT != 0.0
                    ? ((discountedValue * pdtQty * itemVAT) / 100).toFixed(2)
                    : 0;

                api.row(rowIdx).invalidate().draw();
                if (orderDetails.group_id == 3) {
                  getOrderDiscount(
                    api,
                    orderDetails.group_id,
                    orderDetails.time,
                    orderDetails.date
                  );
                }

                calculateTotals(api);
              } else {
                console.warn(`No row found with ID: ${id}`);
              }
            });
        });

        // updateFooter(api);
      },
    });

    return () => {
      table.destroy();
    };
  }, [productDetails, totalVal]);

  const getOrderDiscount = async (api, group_id, time, date) => {
    const allData = api.rows().data().toArray();

    // Log the data for debugging
    // console.log(allData); // Check what `allData` contains

    const totalzeroGoods =
      allData.length === 0
        ? 0
        : allData
          .filter(
            (item) =>
              item.item_tax === "0.00" ||
              item.item_tax === null ||
              (item.item_tax === 0 && item.isContractPriceApplied === "N")
          )
          .reduce((sum, item) => sum + (parseFloat(item.subtotal) || 0), 0);

    const totalstd =
      allData.length === 0
        ? 0
        : allData
          .filter(
            (item) =>
              item.item_tax !== "0.00" &&
              item.item_tax != null &&
              item.item_tax !== 0 &&
              item.isContractPriceApplied === "N"
          )
          .reduce((sum, item) => sum + (parseFloat(item.subtotal) || 0), 0);

    const totalamt = totalzeroGoods + totalstd;
    const formData = new FormData();
    formData.append("group_id", group_id);
    formData.append("totalamt", totalamt);
    formData.append("order_time", time);
    formData.append("order_date", date);
    const apiUrl = `${config.API_URL}/ws_check_Order_Discount_New`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Not Order Report");
      }
      const data = await response.json();

      setTotalVal((prevState) => ({
        ...prevState,
        orderDiscount: parseFloat(data.discount),
        orderDiscountPercentage: data.percentage,
        orderDiscountType: data.discount_type,
      }));

      if (data.success) {
        processNewData(data);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  // totalTax

  const updateDiscountValue = (e) => {
    let newDiscount = parseFloat(e.target.value);
    newDiscount = isNaN(newDiscount) ? 0 : newDiscount;
    let over_all_discount = newDiscount;

    // Only without contract
    let zeroGoods_without_contract = 0;
    let stdGoods_without_contract = 0;
    let vat_without_contract = 0;
    let cess_without_contract = 0;

    // With contract
    let zeroGoods_with_contract = 0;
    let stdGoods_with_contract = 0;
    let vat_with_contract = 0;
    let cess_with_contract = 0;

    productDetails.forEach((item) => {
      const itemTax = parseFloat(item.item_tax) || 0;
      const subtotal = parseFloat(item.subtotal) || 0;
      const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
      const itemCessAmt = ((subtotal * itemCessRate) / 100);
      
      if (item.isContractPriceApplied === "N") {
        if (itemTax !== 0 && itemTax !== "0.00") {
          vat_without_contract += itemTax;
          stdGoods_without_contract += subtotal;
          if (showCessRate === 'Y') {
            cess_without_contract += itemCessAmt;
          }
        } else {
          zeroGoods_without_contract += subtotal;
        }
      } else {
        if (itemTax !== 0 && itemTax !== "0.00") {
          vat_with_contract += itemTax;
          stdGoods_with_contract += subtotal;
          if (showCessRate === 'Y') {
            cess_with_contract += itemCessAmt;
          }
        } else {
          zeroGoods_with_contract += subtotal;
        }
      }
    });

    let totalDiscountOnVat = 0;
    if (over_all_discount > 0) {
      totalDiscountOnVat += over_all_discount;
    }
    if (parseFloat(totalVal.orderDiscountPercentage) > 0) {
      totalDiscountOnVat += Number(
        parseFloat(totalVal.orderDiscountPercentage)
      );
    }

    if (totalDiscountOnVat > 100) {
      Swal.fire({
        title: "error",
        text: "Please enter valid discount.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    // Only apply discount to without contract VAT
    const discountedVatWithoutContract =
      vat_without_contract - (vat_without_contract * totalDiscountOnVat) / 100;
    const totalVat = discountedVatWithoutContract + vat_with_contract;
    console.log("Total VAT:", totalVat);
    // Only apply overall discount to without contract products
    const totalWithoutContract =
      zeroGoods_without_contract + stdGoods_without_contract;
    let InvDiscount = 0;
    if (over_all_discount > 0) {
      InvDiscount = (totalWithoutContract * over_all_discount) / 100;
    } else {
      InvDiscount = 0.0;
    }

    // Calculate total CESS
    const totalCess = cess_without_contract + cess_with_contract;
    
    // Grand total is sum of all products, minus discounts
    const total =
      zeroGoods_without_contract +
      stdGoods_without_contract +
      zeroGoods_with_contract +
      stdGoods_with_contract;
    let orderDiscount = parseFloat(totalVal.orderDiscount) || 0;
    const grandTotal =
      total +
      Number(totalVat.toFixed(2)) +
      Number(totalCess.toFixed(2)) -
      Number(InvDiscount.toFixed(2)) -
      orderDiscount;

    setTotalVal((prevState) => ({
      ...prevState,
      totalTax: formatNumber(totalVat),
      totalCess: formatNumber(totalCess),
      invDiscount: formatNumber(InvDiscount),
      over_all_discount: formatNumber(over_all_discount),
      grandTotal: formatNumber(grandTotal),
    }));
  };
  const newInvoice = async (
    orderId,
    productId,
    order_type,
    qty,
    Comboqty,
    time,
    date
  ) => {
    const formData = new FormData();

    // setProductDetails(updatedProductDetails);
    formData.append("orderId", orderId);
    formData.append("productId", productId);
    formData.append("order_type", order_type);
    formData.append("order_time", time);
    formData.append("order_date", date);
    formData.append("qty", qty);
    formData.append("group_id", orderDetails.group_id);
    // if (productDetails && productDetails.length > 0) {
    //   formData.append("Comboqty", Comboqty);
    // } else {
    //   formData.append("Comboqty", 0);
    // }
    if (productDetails && productDetails.length > 0) {
      formData.append("Comboqty", JSON.stringify(Comboqty));
    } else {
      formData.append("Comboqty", JSON.stringify({})); // Append an empty object as a string
    }

    const apiUrl = `${config.API_URL}/ws_check_Product_Promation_New`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Not Order Report");
      }
      const data = await response.json();

      if (data.success) {
        processNewData(data);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const RemoveComboProduct = async (
    orderId,
    productId,
    order_type,
    qty,
    promo_name,
    date,
    time,
    promo_id
  ) => {
    const formData = new FormData();
    formData.append("orderId", orderId);
    formData.append("productId", productId);
    formData.append("order_type", order_type);
    formData.append("qty", qty);
    formData.append("order_time", time);
    formData.append("order_date", date);
    formData.append("group_id", orderDetails.group_id);
    if (productDetails && productDetails.length > 0) {
      formData.append(
        "Comboqty",
        sumComboQuantitiesByPromoId(productDetails, promo_id) - qty
      );
    } else {
      formData.append("Comboqty", 0);
    }

    const apiUrl = `${config.API_URL}/ws_check_Product_Promation_New`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Not Order Report");
      }
      const data = await response.json();

      //return data;
      //console.log(data);
      if (data.success) {
        processNewData(data);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const processNewData = (rowData) => {
    const newProduct = rowData.item;
    if (newProduct) {
      setProductDetails((prevDetails) => {
        const updatedDetails = [...prevDetails];
        const existingProductIndex = updatedDetails.findIndex(
          (product) =>
            product.product_id === newProduct.product_id &&
            product.order_type === newProduct.order_type &&
            product.is_promoted === newProduct.is_promoted
        );

        if (existingProductIndex !== -1) {
          // Update existing product
          updatedDetails[existingProductIndex] = {
            ...updatedDetails[existingProductIndex],
            ...newProduct,
          };
        } else {
          const NewProduct2 = {
            product_id: newProduct.product_id,
            id: newProduct.id,
            product_code: newProduct.product_code,
            product_name: newProduct.product_name,
            unit_price: newProduct.unit_price,
            quantity: newProduct.quantity,
            discount: newProduct.item_discount,
            unit_quantity: newProduct.quantity,
            order_type: newProduct.order_type,
            order_qty: newProduct.quantity,
            item_tax: parseFloat(newProduct.item_tax ?? 0).toFixed(2),
            subtotal: parseFloat(newProduct.subTotal ?? 0).toFixed(2),
            tax_rate_percent: 0,
            is_promoted: newProduct.is_promoted,
            promo_id: newProduct.promo_id,
            size: newProduct.size,
            promo_product: "",
            isContractPriceApplied: "N",
            ContractPrice: "",
            free_product: "(F)",
            item_discount: "0.00",
            picked_qty: null,
            accept_qty: null,
            proforma_qty: "0",
            deliver_qty: "0.00",
          };

          updatedDetails.push(NewProduct2);
        }

        return updatedDetails;
      });
    }
  };

  const updateRecord = (product) => {
    const table = $("#salesInvoice").DataTable();
    const rowIdx = table
      .rows()
      .indexes()
      .toArray()
      .find(
        (idx) =>
          table.row(idx).data().id === product.item.id &&
          table.row(idx).data().order_type === product.item.order_type
      );
    //console.log(rowIdx);

    if (rowIdx !== undefined) {
      const rowData = table.row(rowIdx).data();
      Object.assign(rowData, product.item);

      if (parseFloat(product.item.quantity) === 0.0) {
        // Remove the row if quantity is 0.00
        table.row(rowIdx).remove().draw();
      } else {
        // Update the row if quantity is not 0.00
        //table.row(rowIdx).data(product.item).draw();

        table.row(rowIdx).data(rowData).invalidate().draw();
      }
    } else {
      console.warn(
        `No row found with Product ID: ${product.item.product_id} and Order Type: ${product.item.order_type}`
      );
    }
  };

  const calculateTotals = (api) => {
    const allData = api.rows().data().toArray();

    // Without contract
    const totalzeroGoods_without_contract = allData
      .filter(
        (item) =>
          (item.item_tax === "0.00" ||
            item.item_tax === null ||
            item.item_tax === 0) &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalstd_without_contract = allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalTax_without_contract = allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

    // With contract
    const totalzeroGoods_with_contract = allData
      .filter(
        (item) =>
          (item.item_tax === "0.00" ||
            item.item_tax === null ||
            item.item_tax === 0) &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalstd_with_contract = allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalTax_with_contract = allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

    // Calculate CESS totals
    const totalCess_without_contract = showCessRate === 'Y' ? allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.subtotal) || 0;
        const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
        return sum + ((itemSubtotal * itemCessRate) / 100);
      }, 0) : 0;

    const totalCess_with_contract = showCessRate === 'Y' ? allData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.subtotal) || 0;
        const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
        return sum + ((itemSubtotal * itemCessRate) / 100);
      }, 0) : 0;

    // Totals
    const totalzeroGoods =
      totalzeroGoods_without_contract + totalzeroGoods_with_contract;
    const totalstd = totalstd_without_contract + totalstd_with_contract;
    const totalCess = totalCess_without_contract + totalCess_with_contract;

    // Only apply discounts to without contract
    const orderDiscount = parseFloat(totalVal.orderDiscount) || 0.0;
    const orderDiscountPercentage =
      parseFloat(totalVal.orderDiscountPercentage) || 0.0;
    const orderDiscountType = totalVal.orderDiscountType || "";
    const over_all_discount =
      parseFloat($("#over_all_discount").val()) ||
      parseFloat(totalVal.over_all_discount) ||
      0.0;

    // Calculate total discount percentage for VAT (only without contract)
    let totalDiscountOnVat = 0;
    if (over_all_discount > 0) {
      totalDiscountOnVat += over_all_discount;
    }
    if (orderDiscountPercentage > 0) {
      totalDiscountOnVat += orderDiscountPercentage;
    }

    // Apply VAT discount only to without contract VAT
    const discountedVatWithoutContract =
      totalTax_without_contract -
      (totalTax_without_contract * totalDiscountOnVat) / 100;
    const totalVat = discountedVatWithoutContract + totalTax_with_contract;

    // Only apply overall discount to without contract products
    const totalWithoutContract =
      totalzeroGoods_without_contract + totalstd_without_contract;
    let invDiscount = 0;
    if (over_all_discount > 0) {
      invDiscount = (totalWithoutContract * over_all_discount) / 100;
    } else {
      invDiscount = parseFloat(totalVal.invDiscount) || 0.0;
    }

    const total = totalzeroGoods + totalstd;
    const grandTotal =
      total +
      Number(parseFloat(totalVat).toFixed(2)) +
      Number(parseFloat(totalCess).toFixed(2)) -
      invDiscount -
      orderDiscount;

    setTotalVal({
      totalstd: formatNumber(totalstd),
      totalzeroGoods: formatNumber(totalzeroGoods),
      totalTax: formatNumber(totalVat),
      totalCess: formatNumber(totalCess),
      orderDiscount: formatNumber(orderDiscount),
      invDiscount: formatNumber(invDiscount),
      over_all_discount: formatNumber(over_all_discount),
      grandTotal: Number(parseFloat(grandTotal).toFixed(2)),
      orderDiscountPercentage: orderDiscountPercentage,
      orderDiscountType: orderDiscountType,
    });
  };

  useEffect(() => {
    // alert(productInputValue.value);

    const fetchProductPrice = async () => {
      if (orderType && productInputValue?.value) {
        const formData = new FormData();
        formData.append("productId", productInputValue.value);
        formData.append("customerId", orderDetails.customer_id);
        formData.append("order_type", orderType.toLowerCase());
        formData.append("order_date", orderDetails.date);
        formData.append("order_time", orderDetails.time);
        const apiUrl = `${config.API_URL}/ws_get_product_byid_new`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          });

          if (!response.ok) {
            throw new Error("Failed to fetch product price");
          }
          const data = await response.json();
          //console.log('Product Price Data:', data);
          setOrderPrice(data.price);
          setNewTaxRate(data.taxRate);
          setisContractPriceApplied(data.isContractPriceApplied);

          // Handle the data as needed
        } catch (error) {
          console.error("Error fetching product price:", error);
        }
      }
    };
    fetchProductPrice();
  }, [orderType, productInputValue, orderDetails.customer_id]);

  const addProductSubmit = async () => {
    const formData = new FormData();
    formData.append("product_id", productInputValue.value);
    formData.append("orderId", orderDetails.id);
    formData.append("qty_of_invoice", addOrderQty);
    formData.append("price_of_invoice", orderPrice);
    formData.append("order_type", orderType.toLowerCase());
    formData.append("order_date", orderDetails.date);
    formData.append("order_time", orderDetails.time);
    const apiUrl = `${config.API_URL}/ws_add_new_product_new`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to submit add product form");
      }
      const data = await response.json();
      Swal.fire({
        title: "Success",
        text: "Product added successfully.",
        icon: "success",
        confirmButtonText: "Close",
      });

      let newProduct = productOptions.find(
        (item) => item.value === productInputValue.value
      );
      let subTotal = addOrderQty * orderPrice;
      let item_tax = (subTotal * parseFloat(newTaxRate)) / 100;
      let ContractPrice = "";
      if (data.isContractPriceApplied === "Y") {
        ContractPrice = "(C)";
      }

      const NewProduct = {
        product_id: productInputValue.value,
        id: String(data.id),
        promo_id: data.promoId,
        promo_name: data.promo_name,
        product_code: newProduct.code,
        product_name: newProduct.name,
        isContractPriceApplied: data.isContractPriceApplied,
        ContractPrice: ContractPrice,
        unit_price: orderPrice,
        quantity: addOrderQty,
        discount: "0.00",
        unit_quantity: 0,
        order_type: orderType.toLowerCase(),
        order_qty: 0,
        item_tax: item_tax.toFixed(2),
        subtotal: subTotal.toFixed(2),
        tax_rate_percent: newTaxRate,
        is_promoted: "0",
        size: newProduct.size,
        item_discount: "0.00",
        picked_qty: null,
        accept_qty: null,
        proforma_qty: "0",
        deliver_qty: "0.00",
        promo_product: data.promo_product,
        free_product: "",
      };

      // Check if the product already exists in the productDetails array
      const existingProductIndex = productDetails.findIndex(
        (item) => item.id === data.id
      );

      let currentQty = 0;
      if (existingProductIndex !== -1) {
        // If the product exists, update its quantity, subtotal, and item tax
        const updatedProductDetails = [...productDetails];
        currentQty = parseFloat(
          updatedProductDetails[existingProductIndex].quantity
        );
        updatedProductDetails[existingProductIndex].quantity =
          currentQty + parseFloat(addOrderQty);
        updatedProductDetails[existingProductIndex].subtotal = (
          parseFloat(updatedProductDetails[existingProductIndex].subtotal) +
          subTotal
        ).toFixed(2);
        updatedProductDetails[existingProductIndex].item_tax = (
          parseFloat(updatedProductDetails[existingProductIndex].item_tax) +
          item_tax
        ).toFixed(2);

        setProductDetails(updatedProductDetails);
      } else {
        // If the product does not exist, add it to the array
        const newProductList = [...productDetails, NewProduct];
        setProductDetails(newProductList);
      }

      // Calculate the total quantity (currentQty + addOrderQty)
      const totalQty = currentQty + parseFloat(addOrderQty);

      // Update the backend with the new or updated product
      const output =
        orderType.toLowerCase() === "box"
          ? "0"
          : orderType.toLowerCase() === "piece"
            ? "1"
            : "";
      const order_type = output;
      // const Comboqty = sumComboQuantities(productDetails) + parseFloat(addOrderQty);
      const Comboqty = sumComboQuantitiesByPromoId(
        productDetails,
        String(data.promoId)
      );
      if (data.isContractPriceApplied === "N") {
        await newInvoice(
          orderDetails.id,
          productInputValue.value,
          order_type,
          totalQty,
          Comboqty,
          orderDetails.time,
          orderDetails.date
        );
      }
      // Recalculate totals
      const updatedProductData =
        existingProductIndex !== -1
          ? productDetails
          : [...productDetails, NewProduct];
      recalculateTotals(updatedProductData, orderDetails);
    } catch (error) {
      console.error("Error submitting product:", error);
    }
  };

  const recalculateTotals = (productData, orderData) => {
    // Without contract
    const totalstd_without_contract = productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalzeroGoods_without_contract = productData
      .filter(
        (item) =>
          (item.item_tax === "0.00" ||
            item.item_tax === null ||
            item.item_tax === 0) &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalTax_without_contract = productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

    // With contract
    const totalstd_with_contract = productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalzeroGoods_with_contract = productData
      .filter(
        (item) =>
          (item.item_tax === "0.00" ||
            item.item_tax === null ||
            item.item_tax === 0) &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalTax_with_contract = productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

    // Calculate CESS totals
    const totalCess_without_contract = showCessRate === 'Y' ? productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "N"
      )
      .reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.subtotal) || 0;
        const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
        return sum + ((itemSubtotal * itemCessRate) / 100);
      }, 0) : 0;

    const totalCess_with_contract = showCessRate === 'Y' ? productData
      .filter(
        (item) =>
          item.item_tax !== "0.00" &&
          item.item_tax != null &&
          item.item_tax !== 0 &&
          item.isContractPriceApplied === "Y"
      )
      .reduce((sum, item) => {
        const itemSubtotal = parseFloat(item.subtotal) || 0;
        const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
        return sum + ((itemSubtotal * itemCessRate) / 100);
      }, 0) : 0;

    // Totals
    const totalstd = totalstd_without_contract + totalstd_with_contract;
    const totalzeroGoods =
      totalzeroGoods_without_contract + totalzeroGoods_with_contract;
    const totalCess = totalCess_without_contract + totalCess_with_contract;

    // Only apply discounts to without contract
    const orderDiscount = parseFloat(orderData.order_discount) || 0.0;
    const orderDiscountPercentage = parseFloat(orderData.percentage) || 0.0;
    const orderDiscountType = orderData.discount_type || "";
    const over_all_discount = parseFloat(orderData.over_all_discount) || 0.0;

    // Calculate total discount percentage for VAT (only without contract)
    let totalDiscountOnVat = 0;
    if (over_all_discount > 0) {
      totalDiscountOnVat += over_all_discount;
    }
    if (orderDiscountPercentage > 0) {
      totalDiscountOnVat += orderDiscountPercentage;
    }

    // Apply VAT discount only to without contract VAT
    const discountedVatWithoutContract =
      totalTax_without_contract -
      (totalTax_without_contract * totalDiscountOnVat) / 100;
    const totalVat = discountedVatWithoutContract + totalTax_with_contract;
    console.log("totalVat", totalVat);
    // Only apply overall discount to without contract products
    const totalWithoutContract =
      totalzeroGoods_without_contract + totalstd_without_contract;
    let InvDiscount = 0;
    if (over_all_discount > 0) {
      InvDiscount = (totalWithoutContract * over_all_discount) / 100;
    } else {
      InvDiscount = 0.0;
    }

    const total = totalzeroGoods + totalstd;
    const grandTotal =
      total +
      Number(totalVat.toFixed(2)) +
      Number(totalCess.toFixed(2)) -
      Number(InvDiscount.toFixed(2)) -
      orderDiscount;

    setTotalVal({
      totalstd: formatNumber(totalstd),
      totalzeroGoods: formatNumber(totalzeroGoods),
      totalTax: formatNumber(totalVat),
      totalCess: formatNumber(totalCess),
      orderDiscount: formatNumber(orderDiscount),
      invDiscount: formatNumber(InvDiscount),
      over_all_discount: formatNumber(over_all_discount),
      grandTotal: formatNumber(grandTotal),
      orderDiscountPercentage: orderDiscountPercentage,
      orderDiscountType: orderDiscountType,
    });
  };

  const ClearModalData = async () => {
    setAddOrderQty("");
    setOrderPrice("");
    setOrderOptions([]);
    setProductInputValue("");
  };

  const submitOrderDetails = async (action = "confirm") => {
    const formData = new FormData();
    formData.append("orderId", orderDetails.id);
    formData.append("status", "Proforma");
    formData.append("group_id", orderDetails.group_id);
    formData.append(
      "delivery_address",
      orderDetails.delivery_address ? orderDetails.delivery_address : ""
    );
    const productDetailsJson = JSON.stringify(productDetails);
    const productDetailsUrlEncoded = encodeURIComponent(
      JSON.stringify(productDetails)
    );

    formData.append("over_all_amount", totalVal.invDiscount);
    formData.append("over_all_discount", totalVal.over_all_discount);
    formData.append("orderList", productDetailsJson);
    formData.append("staffNote", orderDetails.staff_note);
    formData.append("order_date", orderDetails.date);
    formData.append("order_time", orderDetails.time);
    formData.append("userId", localStorage.getItem("userId"));
    const apiUrl = `${config.API_URL}/ws_update_invoice_new`;
    try {
      const { response, data } = await postEncryptedFormFromFormData(
        apiUrl,
        accessToken,
        formData
      );

      if (!response.ok) {
        throw new Error("Failed to submit add product form");
      }
      console.log(data);

      if (data.success) {
        Swal.fire({
          title: "Success!",
          text: action === "confirm" 
            ? "Invoice successfully Updated and Confirmed." 
            : "Invoice successfully Saved.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        
        if (action === "confirm") {
          navigateToGRNList("/picking/proforma");
        }
      } else {
        Swal.fire({
          title: "error",
          text: "Something wrong try again.",
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    } catch (error) {
      console.error("Error submit product:", error);
    }
  };

  const saveChanges = async () => {
    await submitOrderDetails("save");
  };

  const saveAndConfirm = async () => {
    const result = await Swal.fire({
      title: 'Confirm Action',
      text: 'Are you sure you want to save and confirm this proforma invoice? This action cannot be undone.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Save and Confirm',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      await submitOrderDetails("confirm");
    }
  };

  return (
    <>
      <Header />

      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard">
                <i className="fa fa-home"></i>
              </Link>
              <Link to="/picking/proforma">Proforma</Link>
              <Link to="#">Edit Proforma</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="show-addprod-area dashboard">
                <div className="addnew-product-area">
                  <h3 style={{ lineHeight: "20px", margin: "0px 0px 5px 0px" }}>
                    <span>Edit Invoice</span>
                    <button
                      type="button"
                      className="create-catalogue-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#add-product"
                      onClick={ClearModalData}
                    >
                      Add New Product
                    </button>
                  </h3>
                </div>

                <div className="row">
                  <div className="col-12 col-lg-6 col-sm-6">
                    <p>Customer Name - {orderDetails.name}</p>
                    <p>Account No - {orderDetails.account_no} </p>
                  </div>
                  <div className="col-12 col-lg-6 col-sm-6">
                    <div className="row mb-3">
                      <div className="col-12 col-lg-4 col-sm-12">
                        <label
                          htmlFor="inputText"
                          className="col-form-label"
                          style={{ float: "left" }}
                        >
                          Delivery Address:
                        </label>
                      </div>
                      <div className="col-sm-col-12 col-lg-8 col-sm-12">
                        <input
                          type="text"
                          onChange={handleAddressChange}
                          value={orderDetails.delivery_address}
                          className="form-control delivery-add"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="verical-scrl-wrapper common-table sales-edit-invoice"
                  style={{ margin: "0px 0px 32px 0px" }}
                  id="style-3"
                >
                  <table
                    className="table table-bordered resizable"
                    id="salesInvoice"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Order Qty</th>
                        <th>Allot Qty</th>
                        <th>Current Stock</th>
                        <th>Type</th>
                        <th>Unit price</th>
                        <th>Disc(%)</th>
                        <th>{company_tax_type} Amount</th>
                        <th>Net Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>1107</td>
                        <td>
                          <p class="cut-text">WARRIOR BIRTHDAY CAKE-12x64g</p>
                        </td>
                        <td>2</td>
                        <td>
                          <input type="text" class="form-control" />
                        </td>
                        <td>Box</td>
                        <td>
                          <input type="text" class="form-control" />
                        </td>
                        <td>25.98</td>
                        <td>5.20</td>
                      </tr>
                    </tbody>
                    <tfoot></tfoot>
                  </table>
                  <footer>
                    <td colSpan="12" className="footer-col">
                      <div
                        style={{
                          background: "#eee",
                          padding: "5px",
                          border: "1px solid #eee",
                          borderTop: "none",
                          borderBottom: "none",
                        }}
                      >
                        <table className="table table-bordered table-condensed totals">
                          <tbody>
                            <tr className="warning">
                              <td>Zero VAT Goods : {totalVal.totalzeroGoods}</td>
                              <td>VAT Goods : {totalVal.totalstd}</td>
                              <td>
                                {company_tax_type} Amount : {totalVal.totalTax}
                              </td>
                              <td>
                                Promo Discount: {totalVal.orderDiscount || "0.00"}{" "}
                                {totalVal.orderDiscountType === "percentage" ? (
                                  <span
                                    title="Discount in Percentage"
                                    style={{ color: "blue" }}
                                  >
                                    ({totalVal.orderDiscountPercentage} %)
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <label htmlFor="discountInput">
                                    Inv Disc(%):
                                  </label>
                                  <input
                                    id="discountInput"
                                    autoComplete="off"
                                    type="text"
                                    value={totalVal.over_all_discount}
                                    onChange={(e) => updateDiscountValue(e)}
                                    className="over_all_discount"
                                    style={{
                                      width: "100%",
                                      marginRight: "10px",
                                    }}
                                    readOnly={
                                      parseFloat(totalVal.orderDiscount) > 0
                                    }
                                  />
                                </div>
                              </td>
                              <td>
                                Inv Disc Amt:{" "}
                                <span id="actualDiscount">
                                  {totalVal.invDiscount || "0.00"}
                                </span>
                              </td>
                              <td>Grand Total : {totalVal.grandTotal}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </footer>

                  <div
                    className="col-12"
                    style={{ textAlign: "left", display: "block" }}
                  >
                    <br />
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <label for="staffNote" class="text-right" style={{ minWidth: "100px", margin: "0" }}>
                        Staff Note:
                      </label>
                      <input
                        type="text"
                        id="staffNote"
                        class="form-control"
                        name="staffNote"
                        value={orderDetails.staff_note}
                        onChange={handleChangestaffNote}
                        placeholder="Enter staff note..."
                        style={{ flex: "1" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div style={{ display: "flex", gap: "10px", marginBottom: "25px" }}>
                      <button
                        type="button"
                        onClick={saveChanges}
                        className="selectdate-btn"
                        style={{ maxWidth: "150px" }}
                      >
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={saveAndConfirm}
                        className="selectdate-btn"
                        style={{ maxWidth: "150px" }}
                      >
                        Save and Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add-product" tabIndex="-1">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Product</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                <form>
                  <div className="row mb-3 padd-l-13px">
                    <label
                      htmlFor="desc"
                      className="col-sm-12 col-form-label-left"
                    >
                      Select Product
                    </label>
                    <br></br>
                    <div className="col-sm-12">
                      <Select
                        isClearable
                        onInputChange={handleInputChange}
                        onChange={handleChange}
                        options={productOptions}
                        placeholder="Select Product *"
                        value={productInputValue}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label
                      htmlFor="desc"
                      className="col-sm-12 col-form-label-left"
                    >
                      Order Type
                    </label>
                    <br></br>
                    <div className="col-sm-12">
                      <select
                        value={orderType}
                        onChange={handleChangeOrderType}
                        className="form-select"
                      >
                        <option value="">Select Order Type*</option>
                        {orderOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label
                      htmlFor="desc"
                      className="col-sm-12 col-form-label-left"
                    >
                      Price
                    </label>
                    <br></br>
                    <div className="col-sm-12">
                      <input
                        type="text"
                        onChange={handlePriceChange}
                        className="form-control"
                        value={orderPrice}
                        readOnly={isContractPriceApplied === "Y"}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 padd-l-13px">
                    <label
                      htmlFor="desc"
                      className="col-sm-12 col-form-label-left"
                    >
                      QTY
                    </label>
                    <br></br>
                    <div className="col-sm-12">
                      <input
                        type="text"
                        onChange={handleQtyChange}
                        className="form-control"
                        value={addOrderQty}
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="form-group">
                    <input
                      type="button"
                      className="btn btn-secondary common-closebtn"
                      data-bs-dismiss="modal"
                      value="Close"
                      style={{ float: "right", width: "auto" }}
                    />
                    <input
                      type="button"
                      onClick={addProductSubmit}
                      className="common-popup-btn"
                      data-bs-dismiss="modal"
                      value="Save Changes"
                      style={{
                        float: "right",
                        width: "auto",
                        marginRight: "15px",
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default EditProforma_sdm;
